import Api from "./base/api-base";

export default class expenseApi {
  // 費目情報一覧取得
  list() {
    return Api.get({
      endpoint: Api.endpoint.expense,
    });
  }

  // 費目情報登録
  store (params) {
    return Api.post({
      endpoint: Api.endpoint.expense,
      params: params
    });
  }

  // 費目情報取得
  info (id) {
    return Api.get({
      endpoint: Api.endpoint.expense,
      id: id,
    });
  }

  // 費目情報更新
  update (id, params) {
    return Api.post({
      endpoint: Api.endpoint.expense,
      id: id,
      params: params
    });
  }

  // 費目情報削除
  delete(id) {
    return Api.delete({
      endpoint: Api.endpoint.expense,
      id: id,
    });
  }
}
